import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import IssuesModel from '../models/IssuesModel'
import MapLayerSwitcher from './MapLayerSwitcher'
import { Input, Button, Icon  } from 'antd'
import config from 'react-observable-store'
import ol from 'openlayers'

class AdminMapInput extends Component {

    constructor(props) {
        super(props)
        this.onChangeAddress = this.onChangeAddress.bind(this)
        this.renderMap = this.renderMap.bind(this)
        this.mapMarker = false
        this.mapSelectDrag = false

        this.state = {
          address: '',
          markersLoaded: false
        }

        // Init map
        const mapConfig = config.get('globals');
        this.map = IssuesModel.createMap(mapConfig.olmap1)

        // Register events
        this.map.on('moveend', () => {
            const center = this.map.getView().getCenter();
            const zoom = this.map.getView().getZoom();
            this.props.onUpdateCenter(center);
            this.props.onUpdateZoom(zoom);
        })
    }

    componentDidMount() {
        const mapTarget = ReactDOM.findDOMNode(this.refs.map)
        const map = this.map
        IssuesModel.olMap = map
        map.setTarget(mapTarget)
        
        // Add marker editor
        this.mapSelectDrag = this.addMapSelectAndDrag((id, coords) => {
          this.props.updateMarkerCoords(id, coords.native);
        });
    }

    addMapSelectAndDrag(dragCb) {
      var currentId, name;
      var select = new ol.interaction.Select({
        condition: ol.events.condition.pointerMove
      });
      select.on('select', (e) => {
        if (e.selected.length) {
          currentId = e.selected[0].getId();
          name = e.selected[0].get('name');
          this.setState({
              ...this.state,
              address: name
          })
        }
      })
      var translate = new ol.interaction.Translate({
         features: select.getFeatures()
      })
      this.map.addInteraction(select)
      this.map.addInteraction(translate)

      // On translate event
      translate.on('translateend', (a, b) => {
          var coords = {native: [0,0], lonlat: [0,0]}
          coords.native = a.coordinate
          coords.lonlat = ol.proj.transform(a.coordinate, 'EPSG:3857', 'EPSG:4326')
          dragCb(currentId, coords)
      })
      return select
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.markers) {
          var address = this.state.address || nextProps.address;
          this.mapSelectDrag.getFeatures().clear();
          var layer = this.findLayerByName('Ocorrências');
          layer.getSource().clear();
          nextProps.markers.map(local => {
            address = address || local.address;
            let marker = this.putOlMapMarker(local);
            this.mapSelectDrag.getFeatures().push(marker);
            return marker;
          });
          this.setState({
            ...this.state,
            address,
            markersLoaded: true
          });
        }
        this.renderMap();
    }

    componentDidUpdate() {
      this.map.getView().setZoom(this.props.mapZoom);
      this.map.getView().setCenter(this.props.mapCenter);
    }

    findLayerByName(name) {
        var layer
        this.map.getLayers().forEach((l) => {
            if (l.get('name') === name) {
                layer = l
            }
        });
        return layer;  
    }

    zoomToMarkers() {
      var layer = this.findLayerByName('Ocorrências');
      this.map.getView().fit(layer.getSource().getExtent(), { nearest: true });
    }

    createMarker(id, coords, address) {
      var feature = new ol.Feature({
          name: address,
          geometry: new ol.geom.Point(coords)
      });
      feature.setId(id);
      var style = IssuesModel.getProgramMarkerSelectedStyle()
      feature.setStyle(style)
      return feature
    }

    putOlMapMarker(local) {
      var marker, layer = this.findLayerByName('Ocorrências');
      marker = this.createMarker(local.id, [local.x, local.y], local.address);
      layer.getSource().addFeature(marker)
      return marker;
    }

    putOlMapMarkerOnCenter() {
      const coords = this.map.getView().getCenter();
      var id = parseInt(Math.random() * 800000 + 100000, 10);
      var local = { id, x: coords[0], y: coords[1], address: this.state.address };
      this.props.addLocal(local);
    }

    clearOlMapMarker() {
      this.props.clearLocals();
    }

    renderMap() {
        const mapTarget = ReactDOM.findDOMNode(this.refs.map)
        const updateMap = setInterval(() => {
            if (mapTarget.offsetHeight) {
                this.map.updateSize()
                return clearInterval(updateMap)
            }
        }, 50)
    }

    /**
     * Use google maps geocoder
     * @param  {[type]} extent [description]
     * @return {[type]}        [description]
     */
    gmapsGeocoder = (address) => {
      const geocoder = new window.google.maps.Geocoder()
      geocoder.geocode({ 'address': address }, (results, status) => {
          if (
            (status === window.google.maps.GeocoderStatus.OK)
            && (results.length)
            && (results[0].geometry)
            && (results[0].geometry.location)
          ) {
            const lat = results[0].geometry.location.lat()
            const lng = results[0].geometry.location.lng()
            const coords = ol.proj.transform([lng, lat], 'EPSG:4326', 'EPSG:3857')

            // Validate coords
            if (coords) {
              this.map.getView().setCenter(coords);
              this.map.getView().setZoom(14);
            }
          }
      })
    }

    onUpdateAddress(address) {
      this.setState({
        ...this.state,
        address
      }, () => {
        this.props.onUpdateAddress(address)
      })
    }

    onChangeAddress() {
        this.gmapsGeocoder(this.state.address)
    }

    componentWillUnmount() {
        this.map.setTarget(null)
    }

    noAccents(s) {
        var r = s.toLowerCase();
        r = r.replace(new RegExp("\\s", 'g'),"");
        r = r.replace(new RegExp("[àáâãäå]", 'g'),"a")
        r = r.replace(new RegExp("æ", 'g'),"ae")
        r = r.replace(new RegExp("ç", 'g'),"c")
        r = r.replace(new RegExp("[èéêë]", 'g'),"e")
        r = r.replace(new RegExp("[ìíîï]", 'g'),"i")
        r = r.replace(new RegExp("ñ", 'g'),"n")
        r = r.replace(new RegExp("[òóôõö]", 'g'),"o")
        r = r.replace(new RegExp("œ", 'g'),"oe")
        r = r.replace(new RegExp("[ùúûü]", 'g'),"u")
        r = r.replace(new RegExp("[ýÿ]", 'g'),"y")
        r = r.replace(new RegExp("\\W", 'g'),"")
        return r
    }

    render() {
        return (
            <div className={this.props.className}>

                <div className="ant-row ant-form-item">
                    <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                        <label htmlFor="address" className="ant-form-item-required" title="Localizar por endereço">Localização</label>
                    </div>
                    <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                        <Input ref="address"
                            required="required"
                            value={this.state.address}
                            onChange={(e) => this.onUpdateAddress(e.target.value)}
                            onKeyPress={(e) => e.key === 'Enter' ? this.onChangeAddress() : false }
                            suffix={(<Button type="primary" onClick={(e) => this.onChangeAddress() }>
                                <span className="hide-small">Centrar</span>
                                <span className="hide-medium">
                                    <Icon type="environment" />
                                </span>
                            </Button>)}
                        />
                        <div className="map" id="map" ref="map" style={{height: '252px', marginTop: '24px'}}>
                            <div id="putMapMarker">
                                <Button type="primary" icon="pushpin"
                                    title="Definir localização geográfica"
                                    onClick={(e) => this.putOlMapMarkerOnCenter()}
                                />
                            </div>
                            <div id="delMapMarker">
                                <Button type="danger" icon="delete"
                                    title="Remover todas as localizações"
                                    onClick={(e) => this.clearOlMapMarker()}
                                />
                            </div>
                            <MapLayerSwitcher map={this.map} />
                        </div>
                        
                    </div>
                </div>

            </div>
        )
    }
}

export default AdminMapInput;



// WEBPACK FOOTER //
// ./src/components/AdminMapInput.js